import * as registrationApi from "app/api/registrationApi";
import InputWithLabel from "app/components/FormInputs/components/InputWithLabel/InputWithLabel";
import IconAlert from "app/components/Icon/components/IconAlert/IconAlert";
import IconMail from "app/components/Icon/components/IconMail/IconMail";
import IconTick from "app/components/Icon/components/IconTick/IconTick";
import {
  RegistrationFormModalFieldNames,
  registrationInputMaxLength,
} from "app/utils/const";
import { useEffect, useState } from "react";
import { IntlShape } from "react-intl";

type Props = {
  intl: IntlShape;
  email: string;
  handleChange: (id: string, value: string) => void;
  emailValidated: boolean;
  setEmailValidated: (value: boolean) => void;
};

const Email = ({
  intl,
  email,
  handleChange,
  setEmailValidated,
  emailValidated,
}: Props) => {
  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  const validateEmail = (id: string, value: string) => {
    registrationApi
      .validateEmail({ email: value })
      .then(response => {
        // temporary placeholder for the email validation works with current API response
        if (response.data?.valid) {
          setErrors(prevErrors => ({ ...prevErrors, [id]: "" }));
          setEmailValidated(true);
        } else {
          setErrors(prevErrors =>
            response.data?.message
              ? { ...prevErrors, [id]: response.data.message }
              : { ...prevErrors, [id]: intl.formatMessage({ id: "Required" }) }
          );
          setEmailValidated(false);
        }
      })
      .catch(() => {
        setErrors(prevErrors => ({
          ...prevErrors,
          [id]: intl.formatMessage({ id: "Required  " }),
        }));
        setEmailValidated(false);
      });
  };

  // extra check to validate the email on load in case the user has entered a email before
  useEffect(() => {
    if (email.length > 0) {
      validateEmail(RegistrationFormModalFieldNames.email, email);
    }
  }, []);

  return (
    <div className="form-details__row">
      <div className="form-details__row--input">
        <InputWithLabel
          label={intl.formatMessage({
            id: "home-email",
          })}
          inputId={RegistrationFormModalFieldNames.email}
          value={email}
          onValueChange={handleChange}
          key={RegistrationFormModalFieldNames.email}
          required={true}
          maxLength={registrationInputMaxLength.emailMaxLength}
          icon={<IconMail />}
          placeholder={intl.formatMessage({
            id: "home-register-email-example",
          })}
          validateInput={true}
          error={errors.email}
          handleValidation={validateEmail}
        />
        <span className={`${emailValidated ? "validated" : ""}`}>
          {emailValidated && <IconTick />}
        </span>
        <span>{errors.email && <IconAlert />}</span>
      </div>
    </div>
  );
};

export default Email;
